// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__fD5MU","content":"Spinner_content__65P7v","spinner":"Spinner_spinner__oFUEH","title":"Spinner_title__q03NW","description":"Spinner_description__2D8HY"};